import { useParams } from 'react-router-dom'
import EditUserForm from './EditUserForm'
import { useGetUsersQuery } from './usersApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'

const EditUser = () => {
    useTitle('Edit-User')

    const { id } = useParams()

    const { user } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            user: data?.entities[id]
        }),
    })

    if (!user) return <PulseLoader color={"#FFF"} />

    const content =
        <div className="container w-[25rem] md:w-[80rem] h-[24rem] md:h-[37rem] mx-auto border-2 rounded-lg border-gray-400">
            <EditUserForm user={user} />
        </div>

    return content
}
export default EditUser